import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import InsightsPage from './pages/InsightsPage'
import AdminPage from './pages/AdminPage'

const router = createBrowserRouter(
  [
    {
      path: '/insights',
      element: <InsightsPage />,
    },
    {
      path: '/insights/admin',
      element: <AdminPage />,
    },
    {
      // Express serves this SPA's index.html for every unmatched path, so
      // without this, anything other than the two routes above would
      // otherwise render blank (no route match). Old /reading* paths never
      // reach this SPA at all — server/src/index.ts intercepts them first
      // with a 410 Gone, so this fallback is only for genuinely unknown
      // paths, not for the old renamed route.
      path: '*',
      element: <Navigate to="/insights" replace />,
    },
  ],
  { basename: '/' }
)

export default <RouterProvider router={router} />
